import { IMoveToProjectParams } from '../types/IMoveToProjectParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class MoveDatasourcesToProjectRequest extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('moveDatasourcesToProject', params);
  }
}
